import React from "react";
import "./styles.scss";
import Post from "../PostsList/Post";
import _ from "lodash";
import { showPost } from "../../../api/posts";
import PostPlaceHolder from "../PostsList/PostPlaceHolder";

export default class PostPage extends React.Component {
  componentDidMount() {
    showPost(this.props.match.params.id).then(({ data: { post } }) =>
      this.setState({ post })
    );
  }
  state = { post: null, showComments: true };
  postSetter = post => this.setState({ post });
  render() {
    return (
      <div id="own-post" className="m-4">
        {_.isNull(this.state.post) ? (
          <PostPlaceHolder />
        ) : _.isUndefined(this.state.post) ? (
          <h1>I couldn't find what you are looking for</h1>
        ) : (
          <Post
            showActions
            showComments={this.state.showComments}
            post={this.state.post}
            setPost={this.postSetter}
          />
        )}
      </div>
    );
  }
}
